import { TableManger as TableManager, TABLES } from "../managers/TableManger";
import Table from "./table";
import { showLoader, removeLoader } from "deskera-ui-library";

import ApiConstants from "../constants/ApiConstants";
import http from "../http";
import { getRandomAlphaNumericString } from "../utility/Utility";
import AutomationManager from "../components/automation/AutomationManager";
import UserManager from "../managers/UserManager";

class AutomationService {
  static save(data: any, onSuccess: any, onError: any) {
    showLoader("Saving... Please wait");
    const record = {
      cells: data,
    };
    Table.addRecord(record, TableManager.getTableId(TABLES.PEOPLE_AUTOMATION)).then(
      (response) => {
        removeLoader();
        onSuccess(response);
      },
      (error) => {
        removeLoader();
        onError(error);
      }
    );
  }

  static update(data: any, recordId: any, onSuccess: any, onError: any) {
    showLoader("Updating... Please wait");
    Table.updateRecord(
      data,
      recordId,
      TableManager.getTableId(TABLES.PEOPLE_AUTOMATION)
    ).then(
      (response) => {
        removeLoader();
        onSuccess(response);
      },
      (error) => {
        removeLoader();
        onError(error);
      }
    );
  }

  static getData(recordId: string, onSuccess: any, onError: any) {
    showLoader("Fetching... Please wait");
    Table.getRecordById(
      recordId,
      TableManager.getTableId(TABLES.PEOPLE_AUTOMATION)
    ).then(
      (response) => {
        removeLoader();
        onSuccess(response);
      },
      (error) => {
        removeLoader();
        onError(error);
      }
    );
  }

  static getAllConnections() {
    return http.get(ApiConstants.URL.WORKFLOW.GET_CONNECTIONS).then(
      (res: any) => {
        if (res && res.data) {
          if (res.data.length === 0) {
            AutomationService.createConnection();
          } else {
            const connectionIds = res.data;
            let tenant_connection_id_arr = [];
            if (UserManager.getUserDetails()) {
              tenant_connection_id_arr = connectionIds.filter((c) => c.app_code === "deskera" && c.tenant_id === UserManager.getUserDetails().tenantID);
            }
            if (tenant_connection_id_arr.length > 0) {
              AutomationManager.setConnectionId(tenant_connection_id_arr[0].id);
            } else {
              AutomationService.createConnection();
            }
          }
        }
        return Promise.resolve(res);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  static createConnection() {
    return http
      .post(ApiConstants.URL.WORKFLOW.CREATE_CONNECTION, {
        app_code: "deskera",
        authorization_code: "",
        name: `CRM Connection ${getRandomAlphaNumericString(4)}`,
      })
      .then(
        (res: any) => {
          if (res && res.id) {
            AutomationManager.setConnectionId(res.id);
          }
          return Promise.resolve(res);
        },
        (err) => {
          return Promise.reject(err);
        }
      );
  }
  static getAutomationReport(id, params){
    return http.get(`${ApiConstants.URL.WORKFLOW.FLOW_EXEC}/${id}`, { params: params })
  }

  static updateExpenses(params, payload) {
    const config = {
        headers: {
            "content-type": "application/json"
        },
        params: params
    };

    return http.post(ApiConstants.URL.WORKFLOW.UPDATE_EXPENSES, payload, config);
  }

  static updateTimeoff(params, payload) {
    const config = {
        headers: {
            "content-type": "application/json"
        },
        params: params
    };

    return http.post(ApiConstants.URL.WORKFLOW.UPDATE_TIME_OFF, payload, config);
  }
}

export default AutomationService;
